
// import React, { Component } from 'react';
// import { connect } from 'react-redux';

// import axios from '../../../axios-url';

// // ── Base URL for menu item images ───────────────────────────────────────
// // `photopath` from the backend is just a filename (e.g.
// // "245F24D8-5D28-4EC8-AC54-0056DD96A5C6.png"), not a full URL.
// // Backend serves these as static files from wwwroot/MenuItemsimage
// // (C:\Chenthoor\API\MasterPublish\wwwroot\MenuItemsimage), which ASP.NET
// // Core's static file middleware exposes at /MenuItemsimage/<filename>
// // on the same host as the API.
// //
// // Pulled from the shared axios instance's baseURL (axios-url.js) instead
// // of being hardcoded here, so changing the API host in one place (e.g.
// // switching servers) automatically updates image URLs too.
// const MENU_IMAGE_BASE_URL = `${axios.defaults.baseURL}/MenuItemsimage/`;

// const getMenuImageUrl = (photopath) =>
//     photopath ? `${MENU_IMAGE_BASE_URL}${photopath}` : null;

// class MenuList extends Component {

//     constructor(props) {
//         super(props);
//         this.state = { activeCategory: 'ALL', search: '' };
//     }

//     render() {
//     const { activeCategory, search } = this.state;
//     const {
//         onAddToCart,
//         menuitems = [],
//         menucategory = []
//     } = this.props;

//     const categories = [
//         ...new Set(
//             menuitems
//                 .filter(item => item.menuCategoryId)
//                 .map(item => item.menuCategoryId)
//         )
//     ];

//     const filtered = menuitems.filter(item => {
//         const matchesCategory =
//             activeCategory === 'ALL' ||
//             item.menuCategoryId === activeCategory;

//         const matchesSearch =
//             item.menuName
//                 .toLowerCase()
//                 .includes(search.toLowerCase());

//         return matchesCategory &&
//             matchesSearch &&
//             item.isActive;
//     });

//     return (
//         <div className="pos-menu-list">

//             <div className="pos-menu-categories">

//                 <button
//                     className={activeCategory === 'ALL' ? 'active' : ''}
//                     onClick={() =>
//                         this.setState({ activeCategory: 'ALL' })
//                     }
//                 >
//                     ALL
//                 </button>

//                 {categories.map(categoryValue => {

//                     const category = menucategory.find(
//                         x => x.value === categoryValue
//                     );

//                     return (
//                         <button
//                             key={categoryValue}
//                             className={
//                                 activeCategory === categoryValue
//                                     ? 'active'
//                                     : ''
//                             }
//                             onClick={() =>
//                                 this.setState({
//                                     activeCategory: categoryValue
//                                 })
//                             }
//                         >
//                             {category
//                                 ? category.label
//                                 : categoryValue}
                                
//                         </button>
//                     );
//                 })}

//             </div>

//                 <input
//                     className="pos-menu-search"
//                     placeholder="Search"
//                     value={search}
//                     onChange={(e) => this.setState({ search: e.target.value })}
//                 />

//                 <div className="pos-menu-grid">
//                     {filtered.map(item => {
//                         const imageUrl = getMenuImageUrl(item.photopath);
//                         return (
//                             <div
//                                 key={item.menuItemId}
//                                 className="pos-menu-tile"
//                                 onClick={() => onAddToCart({
//                                     id:       item.menuItemId,
//                                     name:     item.menuName,
//                                     price:    item.sellingPrice,
//                                     category: item.menuCategoryId,
//                                     kitchen:  item.defaultkitchen,
//                                     uom:      item.baseunit,
//                                 })}
//                             >
//                                 <div className="pos-menu-tile-image">
//                                     {imageUrl ? (
//                                         <img
//                                             src={imageUrl}
//                                             alt={item.menuName}
//                                             onError={(e) => {
//                                                 // File missing/renamed on server — fall back to placeholder
//                                                 e.target.onerror = null;
//                                                 e.target.style.display = 'none';
//                                                 e.target.parentElement.classList.add('pos-menu-tile-image--empty');
//                                             }}
//                                         />
//                                     ) : (
//                                         <i className="pi pi-image" />
//                                     )}
//                                 </div>
//                                 <span className="pos-menu-price">
//                                     {item.sellingPrice.toFixed(2)}
//                                 </span>
//                                 <span className="pos-menu-name">{item.menuName}</span>
//                             </div>
//                         );
//                     })}
//                 </div>

//             </div>
//         );
//     }
// }
// const mapStateToProps = (state) => {
//       console.log('keyword slice:', state.keyword);
//     return {
//         menucategory: state.keyword.MenuCategory,
//     };
// };

// export default connect(mapStateToProps)(MenuList);


import React, { Component } from 'react';
import { connect } from 'react-redux';

import axios from '../../../axios-url';

const MENU_IMAGE_BASE_URL = `${axios.defaults.baseURL}/MenuItemsimage/`;

const getMenuImageUrl = (photopath) =>
    photopath ? `${MENU_IMAGE_BASE_URL}${photopath}` : null;

const parseModifiers = (allowedModifier) => {
    if (!allowedModifier || !allowedModifier.trim()) return [];
    return allowedModifier
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
};

const buildModifierState = (modifierIds, Modifier = []) =>
    modifierIds.map((id) => {
        const found = Modifier.find((m) => m.value === id);
        return {
            id,
            name: found ? found.label : id, // fallback to id if not found in master
            price: 20,
            checked: false,
            qty: 1,
        };
    });

// "Extra Cheese, No Onion x2" — the string that ends up both displayed under
// the item (cart + order status) and stored as this row's modifier identity,
// so two adds of the same dish with different add-on choices don't collapse
// into one cart line (see addToCart's existingIndex match in QrOrderDetails.js).
const formatModifiersLabel = (selected) =>
    selected
        .map((m) => (m.qty > 1 ? `${m.name} x${m.qty}` : m.name))
        .join(', ');

class MenuList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeCategory: 'ALL',
            search: '',
            modalOpen: false,
            pendingItem: null,
            modifiers: [],
            keypadOpen: false,
            keypadItem: null,
            keypadValue: '',
        };
    }

    // Only called from the keypad trigger button — NOT from tile click
    openKeypad = (e, item) => {
        e.stopPropagation(); // prevent tile's direct-add from also firing
        this.setState({ keypadOpen: true, keypadItem: item, keypadValue: '' });
    };

    closeKeypad = () => {
        this.setState({ keypadOpen: false, keypadItem: null, keypadValue: '' });
    };

    pressKeypadDigit = (digit) => {
        this.setState((prev) => {
            if (prev.keypadValue.length >= 3) return null; // cap at 999
            return { keypadValue: prev.keypadValue + digit };
        });
    };

    pressKeypadBackspace = () => {
        this.setState((prev) => ({ keypadValue: prev.keypadValue.slice(0, -1) }));
    };

    pressKeypadClear = () => {
        this.setState({ keypadValue: '' });
    };

    confirmKeypad = () => {
        const { keypadItem, keypadValue } = this.state;
        const qty = parseInt(keypadValue, 10);
        if (!qty || qty < 1) return;

        this.props.onAddToCart({
            id:             keypadItem.menuItemId,
            name:           keypadItem.menuName,
            price:          Number(keypadItem.sellingPrice || 0),
            category:       keypadItem.menuCategoryId,
            kitchen:        keypadItem.defaultkitchen,
            uom:            keypadItem.baseunit,
            modifierIds:    [],
            modifierQtys:   '',
            modifiersLabel: '',
            qty,
        });
        this.closeKeypad();
    };

    // Only called from the small trigger button — NOT from tile click
    openModifierModal = (e, item) => {
        e.stopPropagation(); // prevent tile's direct-add from also firing
        const modifierIds = parseModifiers(item.allowedModifier);
        this.setState({
            modalOpen: true,
            pendingItem: item,
            modifiers: buildModifierState(modifierIds, this.props.Modifier),
        });
    };

    closeModal = () => {
        this.setState({ modalOpen: false, pendingItem: null, modifiers: [] });
    };

    toggleModifier = (index) => {
        this.setState((prev) => {
            const modifiers = [...prev.modifiers];
            modifiers[index] = { ...modifiers[index], checked: !modifiers[index].checked };
            return { modifiers };
        });
    };

    changeModifierQty = (index, delta) => {
        this.setState((prev) => {
            const modifiers = [...prev.modifiers];
            modifiers[index] = { ...modifiers[index], qty: Math.max(1, modifiers[index].qty + delta) };
            return { modifiers };
        });
    };

    confirmAddToCart = () => {
        const { pendingItem, modifiers } = this.state;
        const { onAddToCart } = this.props;
        const selected = modifiers.filter((m) => m.checked);

        const modifiersCost = selected.reduce(
        (sum, m) => sum + m.price * m.qty,
        0
    );

        onAddToCart({
            id:             pendingItem.menuItemId,
            name:           pendingItem.menuName,
            price:          Number(pendingItem.sellingPrice || 0) + modifiersCost,
            category:       pendingItem.menuCategoryId,
            kitchen:        pendingItem.defaultkitchen,
            uom:            pendingItem.baseunit,
            // Array, not a joined string — MI_MODIFIER_SEL is a type-3
            // (MULTIDROPDOWN) field, and this schema's save endpoint expects
            // that field's value to serialize as a JSON array ("[]", not "")
            // — see RestaurantOrder.js's buildFieldValue/serializeFieldValue.
            modifierIds:    selected.map((m) => m.id),
            modifierQtys:   selected.map((m) => m.qty).join(','),
            modifiersLabel: formatModifiersLabel(selected),
        });
        this.closeModal();
    };

    // Tile click → direct add, no modal, no modifiers
    handleTileClick = (item) => {
        this.props.onAddToCart({
            id:             item.menuItemId,
            name:           item.menuName,
            price:          Number(item.sellingPrice || 0),
            category:       item.menuCategoryId,
            kitchen:        item.defaultkitchen,
            uom:            item.baseunit,
            modifierIds:    [],
            modifierQtys:   '',
            modifiersLabel: '',
        });
    };

    render() {
        const { activeCategory, search, modalOpen, pendingItem, modifiers, keypadOpen, keypadItem, keypadValue } = this.state;
        const { menuitems = [], menucategory = [] } = this.props;

        const categories = [
            ...new Set(
                menuitems
                    .filter((item) => item.menuCategoryId)
                    .map((item) => item.menuCategoryId)
            ),
        ];

        const filtered = menuitems.filter((item) => {
            const matchesCategory =
                activeCategory === 'ALL' || item.menuCategoryId === activeCategory;
            const matchesSearch = item.menuName?.toLowerCase().includes(search.toLowerCase());
            return matchesCategory && matchesSearch && item.isActive;
        });

        return (
            <div className="pos-menu-list">

                <div className="pos-menu-categories">
                    <button
                        className={activeCategory === 'ALL' ? 'active' : ''}
                        onClick={() => this.setState({ activeCategory: 'ALL' })}
                    >
                        ALL
                    </button>
                    {categories.map((categoryValue) => {
                        const category = menucategory.find((x) => x.value === categoryValue);
                        return (
                            <button
                                key={categoryValue}
                                className={activeCategory === categoryValue ? 'active' : ''}
                                onClick={() => this.setState({ activeCategory: categoryValue })}
                            >
                                {category ? category.label : categoryValue}
                            </button>
                        );
                    })}
                </div>

                <input
                    className="pos-menu-search"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => this.setState({ search: e.target.value })}
                />

                <div className="pos-menu-grid">
                    {filtered.map((item) => {
                        const imageUrl = getMenuImageUrl(item.photopath);
                        const hasModifiers = parseModifiers(item.allowedModifier).length > 0;

                        return (
                            <div
                                key={item.menuItemId}
                                className="pos-menu-tile"
                                onClick={() => this.handleTileClick(item)}
                            >
                                <div className="pos-menu-tile-image">
                                    {imageUrl ? (
                                        <img
                                            src={imageUrl}
                                            alt={item.menuName}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.style.display = 'none';
                                                e.target.parentElement.classList.add('pos-menu-tile-image--empty');
                                            }}
                                        />
                                    ) : (
                                        <i className="pi pi-image" />
                                    )}
                                </div>

                                <span className="pos-menu-price">
                                    {Number(item.sellingPrice || 0).toFixed(2)}
                                </span>
                                <span className="pos-menu-name">{item.menuName}</span>

                                {/*
                                  * Trigger buttons live in normal flex flow (not absolutely
                                  * positioned over the tile) so they reserve their own space
                                  * instead of floating on top of the name/price text — on a
                                  * narrow tile a longer name wraps to more lines and pushes
                                  * the price down, and an absolute overlay would sit on top
                                  * of whatever ended up there instead of making room for it.
                                  * e.stopPropagation() prevents the tile onClick from also firing.
                                */}
                                {/* Qty always left, Add-ons always right — DOM order plus
                                    justify-content: space-between (see _modifiermodal.scss)
                                    keeps that fixed regardless of which buttons are present. */}
                                <div className="pos-menu-tile-actions">
                                    <button
                                        className="pos-keypad-trigger"
                                        title="Enter quantity"
                                        onClick={(e) => this.openKeypad(e, item)}
                                        aria-label={`Enter quantity for ${item.menuName}`}
                                    >
                                        <i className="pi pi-calculator" />
                                        <span className="pos-trigger-label">Qty</span>
                                    </button>

                                    {hasModifiers && (
                                        <button
                                            className="pos-modifier-trigger"
                                            title="Choose add-ons"
                                            onClick={(e) => this.openModifierModal(e, item)}
                                            aria-label={`Add-ons for ${item.menuName}`}
                                        >
                                            <i className="pi pi-sliders-h" />
                                            <span className="pos-trigger-label">Add-ons</span>
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {modalOpen && pendingItem && (
                    <ModifierModal
                        item={pendingItem}
                        modifiers={modifiers}
                        onToggle={this.toggleModifier}
                        onChangeQty={this.changeModifierQty}
                        onConfirm={this.confirmAddToCart}
                        onCancel={this.closeModal}
                    />
                )}

                {keypadOpen && keypadItem && (
                    <KeypadModal
                        item={keypadItem}
                        value={keypadValue}
                        onDigit={this.pressKeypadDigit}
                        onBackspace={this.pressKeypadBackspace}
                        onClear={this.pressKeypadClear}
                        onConfirm={this.confirmKeypad}
                        onCancel={this.closeKeypad}
                    />
                )}
            </div>
        );
    }
}

function ModifierModal({ item, modifiers, onToggle, onChangeQty, onConfirm, onCancel }) {
    const hasSelection = modifiers.some((m) => m.checked);

    return (
        <div className="pos-modifier-backdrop" onClick={onCancel}>
            <div className="pos-modifier-modal" onClick={(e) => e.stopPropagation()}>

                <div className="pos-modifier-modal__header">
                    <div>
                        <span className="pos-modifier-modal__title">{item.menuName}</span>
                        <span className="pos-modifier-modal__subtitle">Choose add-ons</span>
                    </div>
                    <button className="pos-modifier-modal__close" onClick={onCancel} aria-label="Close">
                        <i className="pi pi-times" />
                    </button>
                </div>

                <div className="pos-modifier-modal__body">
                    {modifiers.map((mod, idx) => (
                        <div
                            key={mod.id}
                            className={`pos-modifier-row${mod.checked ? ' pos-modifier-row--checked' : ''}`}
                        >
                            <input
                                type="checkbox"
                                id={`mod-${idx}`}
                                className="pos-modifier-row__check"
                                checked={mod.checked}
                                onChange={() => onToggle(idx)}
                            />
                            <label htmlFor={`mod-${idx}`} className="pos-modifier-row__label">
                                {mod.name}
                                <span className="pos-modifier-row__price"> (+₹{mod.price.toFixed(2)})</span>
                            </label>
                            <div className={`pos-modifier-row__qty${!mod.checked ? ' pos-modifier-row__qty--disabled' : ''}`}>
                                <button
                                    className="pos-modifier-row__qty-btn"
                                    onClick={() => onChangeQty(idx, -1)}
                                    disabled={!mod.checked}
                                    aria-label="Decrease"
                                >−</button>
                                <span className="pos-modifier-row__qty-val">{mod.qty}</span>
                                <button
                                    className="pos-modifier-row__qty-btn"
                                    onClick={() => onChangeQty(idx, 1)}
                                    disabled={!mod.checked}
                                    aria-label="Increase"
                                >+</button>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="pos-modifier-modal__footer">
                    <button
                        className="pos-modifier-modal__btn pos-modifier-modal__btn--cancel"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="pos-modifier-modal__btn pos-modifier-modal__btn--add"
                        onClick={onConfirm}
                    >
                        {hasSelection ? 'Add with modifiers' : 'Add without modifiers'}
                    </button>
                </div>
            </div>
        </div>
    );
}

const KEYPAD_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'clear', '0', 'backspace'];

function KeypadModal({ item, value, onDigit, onBackspace, onClear, onConfirm, onCancel }) {
    const qty = parseInt(value, 10);
    const canConfirm = !!qty && qty > 0;

    // Keyboard support while the modal is open — mount/unmount tracks
    // open/close exactly (this component only ever renders while
    // keypadOpen is true), so a plain effect is enough, no extra state.
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key >= '0' && e.key <= '9') {
                e.preventDefault();
                onDigit(e.key);
            } else if (e.key === 'Enter') {
                e.preventDefault();
                if (canConfirm) onConfirm();
            } else if (e.key === 'Backspace') {
                // Prevent default too — with no input focused, Backspace
                // can trigger the browser's "navigate back" in some browsers.
                e.preventDefault();
                onBackspace();
            } else if (e.key === 'Escape') {
                e.preventDefault();
                onCancel();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [canConfirm, onDigit, onConfirm, onBackspace, onCancel]);

    return (
        <div className="pos-keypad-backdrop" onClick={onCancel}>
            <div className="pos-keypad-modal" onClick={(e) => e.stopPropagation()}>

                <div className="pos-keypad-modal__header">
                    <div>
                        <span className="pos-keypad-modal__title">{item.menuName}</span>
                        <span className="pos-keypad-modal__subtitle">Enter quantity</span>
                    </div>
                    <button className="pos-keypad-modal__close" onClick={onCancel} aria-label="Close">
                        <i className="pi pi-times" />
                    </button>
                </div>

                <div className="pos-keypad-modal__display">
                    {value || '0'}
                </div>

                <div className="pos-keypad-modal__grid">
                    {KEYPAD_KEYS.map((key) => {
                        if (key === 'clear') {
                            return (
                                <button key={key} className="pos-keypad-modal__key pos-keypad-modal__key--action" onClick={onClear}>
                                    C
                                </button>
                            );
                        }
                        if (key === 'backspace') {
                            return (
                                <button key={key} className="pos-keypad-modal__key pos-keypad-modal__key--action" onClick={onBackspace} aria-label="Backspace">
                                    <i className="pi pi-arrow-left" />
                                </button>
                            );
                        }
                        return (
                            <button key={key} className="pos-keypad-modal__key" onClick={() => onDigit(key)}>
                                {key}
                            </button>
                        );
                    })}
                </div>

                <div className="pos-keypad-modal__footer">
                    <button
                        className="pos-keypad-modal__btn pos-keypad-modal__btn--cancel"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="pos-keypad-modal__btn pos-keypad-modal__btn--add"
                        onClick={onConfirm}
                        disabled={!canConfirm}
                    >
                        Add {canConfirm ? qty : ''}
                    </button>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    console.log('keyword slice:', state.keyword);
    return {
        menucategory: state.keyword.MenuCategory,
        Modifier:state.keyword.Modifier
    };
};

export default connect(mapStateToProps)(MenuList);